import React, { createContext, useContext, ReactNode } from 'react';
import { useNavigation } from '../hooks/use-navigation';

interface NavigationContextType {
    path: string | null;
}

const NavigationContext = createContext<NavigationContextType>({ path: null });

function NavigationProvider({ children }: { children: ReactNode }) {
    const navigation = useNavigation();

    return (
        <NavigationContext.Provider value={navigation}>
            {children}
        </NavigationContext.Provider>
    );
}

function usePreviousPath() {
    return useContext(NavigationContext);
}

export {
    NavigationProvider,
    usePreviousPath,
};
